import { FormGroup } from '@angular/forms';
import { Injectable } from '@angular/core';
import { Component } from '@angular/compiler/src/core';

@Injectable()
export class FormService {

  // get all values of the formGroup, loop over them
  // then mark each field as touched
  public markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach(control => {
      control.markAsTouched();

      if (control.controls) {
          this.markFormGroupTouched(control);
      }
    });
  }

  // return list of error messages
  public validationMessages() {
    const messages = {
      required: 'This field is required',
      selectAtLeastOneGridRow: 'Select at least one item from the grid',
      selectAtLeastOneFilter_HotRequests: 'Select either "Supplier Code" or "Part Number" filter',
      selectAtleastOneImage: 'Select at least one image each for Part & Package',
      invalidPartNumberList: 'Invalid/Empty value detected for part numbers list',
      selectAtleastOneTestingDocument: 'Select at least one testing document or provide a reason for not submitting. Specify reason if selecting the \'Other\' option.',
      valueLessThanPreviousLayer: 'Value should be greater than Previous Layer',
      canNotUseSameUOMForCopy: 'Select at least one item from the grid',
      lastLayerIsNotShippable: '',
      email: 'This email address is invalid',
      min: (min: number) => 'Value should be greater than ' + min,
      max: (max: number) => 'Value should be less than ' + max,
      totalWeightExceedsMaxAllowed: (maxWeight: number) => 'Exceeded Max allowed',
      minlength: (requiredLength: number) => 'Minimum length should be ',
      maxlength: (requiredLength: number) => 'Length should not exceed ',
      pattern: (pattern: string) => {
          return 'Max decimal places exceeded.';
      },
      //dateGreaterThan: (date: string) => ''
      DateLessThanToday: 'Date should be greater than Today\'s date',
      EffectiveFromIsBeforeEffectiveTo: 'Invalid Date span',
      invalidEffectiveFromDate: 'The earliest Effective start date can be Today + 1 day',
      invalid_characters: (matches: any[]) => {

        let matchedCharacters = matches;

        matchedCharacters = matchedCharacters.reduce((characterString, character, index) => {
          let string = characterString;
          string += character;

          if (matchedCharacters.length !== index + 1) {
            string += ', ';
          }

          return string;
        }, '');

        return `These characters are not allowed: ${matchedCharacters}`;
      },
    };

    return messages;
  }

  // Validate form instance
  // check_dirty true will only emit errors if the field is touched
  // check_dirty false will check all fields independent of
  // being touched or not. Use this as the last check before submitting
  public validateForm(formToValidate: FormGroup, formErrors: any, checkDirty?: boolean, checkOnlyRequired: boolean = false) {
    const form = formToValidate;

    for (const field in formErrors) {
      if (field) {
        formErrors[field] = '';
        const control = form.get(field);

        const messages = this.validationMessages();
        if (control && !control.valid) {
          if (!checkDirty || (control.dirty || control.touched)) {
            for (const key in control.errors) {
              if (key && !checkOnlyRequired) {
                switch (key) {
                  case 'invalid_characters': {
                  formErrors[field] = formErrors[field] || messages[key](control.errors[key]);
                  break;
                  }
                  case 'min': {
                  formErrors[field] = formErrors[field] || messages[key](control.errors.minValue ? control.errors.minValue : control.errors[key].min);
                  break;
                  }
                  case 'max': {
                    formErrors[field] = formErrors[field] || messages[key](control.errors.maxValue ? control.errors.maxValue : control.errors[key].max);
                    break;
                  }
                  case 'minlength': {
                  formErrors[field] = formErrors[field] || messages[key](control.errors[key].minlength) + control.errors.minlength.requiredLength;
                  break;
                  }
                  case 'maxlength': {
                  formErrors[field] = formErrors[field] || messages[key](control.errors[key].maxlength) + control.errors.maxlength.requiredLength;
                  break;
                  }
                  case 'totalWeightExceedsMaxAllowed': {
                  formErrors[field] = formErrors[field] || messages[key](control.errors[key].totalWeightExceedsMaxAllowed);
                  break;
                  }
                  case 'pattern': {
                    formErrors[field] = formErrors[field] || messages[key](control.errors.pattern.requiredPattern);
                  }
                  default:
                  {
                    formErrors[field] = formErrors[field] || messages[key] || control.errors[key];
                  }
                }
              } else { // do only 'required' validation
                if (key == 'required')
                {
                  formErrors[field] = formErrors[field] || messages[key];
                }
              }
            }
          }
        }
      }
    }

    return formErrors;
  }
}
